import React from 'react';

const TwitterIcon = ({ color = '#f2f2f2' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M3.001 17.7848C4.60479 18.802 6.50722 19.3906 8.54656 19.3906C14.2758 19.3906 18.9201 14.7458 18.9201 9.01707C18.9201 8.87403 18.9171 8.73206 18.9116 8.5905C19.1188 8.42743 20.4005 7.40017 20.7146 6.73978C20.7146 6.73978 19.6738 7.17232 18.6552 7.27422C18.6532 7.27422 18.6507 7.2747 18.6487 7.2747C18.6487 7.2747 18.6507 7.27369 18.6542 7.2712C18.748 7.20849 20.0603 6.31523 20.2379 5.25091C20.2379 5.25091 19.5018 5.64384 18.471 5.9876C18.3004 6.04428 18.1218 6.10002 17.9376 6.15168C17.2732 5.44259 16.3288 5 15.2805 5C13.2697 5 11.6403 6.6289 11.6403 8.63815C11.6403 8.92168 11.673 9.19765 11.7347 9.46262C11.4537 9.45109 7.17464 9.21118 4.26362 5.68593C4.26362 5.68593 2.52384 8.06104 5.30039 10.5034C5.30039 10.5034 4.45636 10.4697 3.72818 10.0346C3.72818 10.0346 3.46072 12.912 6.6051 13.6477C6.6051 13.6477 5.98638 13.8821 4.99931 13.715C4.99931 13.715 5.5513 16.0399 8.34493 16.2572C8.34493 16.2572 6.13586 18.2528 3 17.7846L3.001 17.7848Z"
        fill={color}
      />
    </svg>
  );
};

export default TwitterIcon;
